import Background from "../assets/Background1.png";
import LandingPageLogo from "../assets/LandingPageLogo.jsx";
import SidebarCloser from "../assets/SidebarCloser.jsx";
import SidebarRobot from "../assets/SidebarRobot.jsx";
import SidebarProfile from "../assets/SidebarProfile.jsx";
import SidebarPayments from "../assets/SidebarPayments.jsx";
import SidebarQuestions from "../assets/SidebarQuestions.jsx";
import SidebarRating from "../assets/SidebarRating.jsx";
import SidebarMarket from "../assets/SidebarMarket.jsx";
import SidebarSettings from "../assets/SidebarSettings.jsx";
import DashboardTemperature from "../assets/DashboardTemperature.jsx";
import DashboardHumidity from "../assets/DashboardHumidity.jsx";
import DashboardBattery from "../assets/DashboardBattery.jsx";
import Downloads from "../assets/Downloads.jsx";
import Star from "../assets/Star.jsx";
import Search from "../assets/Search.jsx";
import Loader from "../assets/loader.gif";
import SandclockSVG from "../assets/SandclockSVG.jsx";
import GreenTickSVG from "../assets/GreenTickSVG.jsx";

const ICONS = {
  Background,
  LandingPageLogo,
  SidebarCloser,
  SidebarRobot,
  SidebarProfile,
  SidebarPayments,
  SidebarQuestions,
  SidebarRating,
  SidebarMarket,
  SidebarSettings,
  DashboardTemperature,
  DashboardHumidity,
  DashboardBattery,
  Downloads,
  Star,
  Search,
  Loader,
  SandclockSVG,
  GreenTickSVG,
};

export default ICONS;
